import React, { Component, Fragment } from 'react'
import { MuiToggleButtonGroup, MuiToggleButton } from '../MaterialUIComponents';
import theme from '../../../assests/theme'
import { withStyles } from '@material-ui/core/styles';

export const ToggleButtonGroup = withStyles((theme) => ({
    grouped: {
        border: 'none',
        borderRadius: 0,
    },
}))(MuiToggleButtonGroup);

export const ToggleButton = withStyles((theme) => ({
    root: {

        background: theme.palette.primary.lightest,
        font: "Regular 14px/12px Arial",
        border: 'none',
        color: theme.palette.primary.darker,
        "&:hover": {
            backgroundColor: theme.palette.primary.light
        },
    },
    selected: {
        background: theme.palette.primary.light + " !important",
        font: "Bold 14px/12px Arial",

    },
}))(MuiToggleButton);